import { graphql } from "react-relay";
import { AutopilotForm } from "@components/autopilot-form";

export const fragments = {
  org: graphql`
    fragment ChromeCreateEvent_org on Org @argumentDefinitions(calendarIds: { type: "[String]!" }) {
      ...AutopilotForm_org
      id
      domains
      primaryOrgCalendar
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isOutsideOrg
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const chromeCreateEventRendererQuery = graphql`
  query ChromeCreateEventRendererQuery($calendarIds: [String]!, $orgRelayId: ID!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        ...ChromeCreateEvent_org @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
